import { FC, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';

export const CardSkeleton: FC<{
  children: ReactNode;
  labelSize: number;
}> = ({ labelSize, children }) => (
  <div className="card h-100 bg-lvl1">
    <div className="card-body">
      <h5 className="card-title">
        <Skeleton width={labelSize + 'em'} />
      </h5>
      <div className="card-text">{children}</div>
    </div>
  </div>
);
